module.exports = __webpack_public_path__ + "static/media/add_user.2b027bfa.svg";